var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"emptyTip"},[_c('p',[_vm._v("暂无数据")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }